module.exports = __webpack_public_path__ + "static/media/vegas-8.b13cb4a4.jpg";